export default __webpack_public_path__ + "static/media/anytime-giftcard3.65780ddb.webp";